enum PrivilegeSource {
  REGISTRATION_FORM = "REGISTRATION_FORM",
  INVENTORY = "INVENTORY"
}
export default PrivilegeSource;
